import React, {useState} from 'react';
import {Form, Button, Card, Container} from 'react-bootstrap';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {useAppDispatch} from 'src/redux/storeHooks';
import {requestPasswordForgetAsync} from 'src/redux/actions/authActions';
import useAppToast from 'src/hooks/useAppToast';
import {useNavigate} from 'react-router-dom';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email format').required('Email is required'),
});

const StartRoleAccountActivationTest = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {successToast, warningToast, errorToast} = useAppToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: {email: ''},
    validationSchema,
    onSubmit: (values) => {
      setIsSubmitting(true);
      dispatch(requestPasswordForgetAsync({email: values.email}))
        .then((response) => {
          if (response?.payload?.status_code === 200) {
            successToast('Request succeeded. Looking for token...');
            const token =
              response?.payload?.data?.forgot_password_token ||
              response?.payload?.data?.token ||
              response?.payload?.forgot_password_token;

            if (token) {
              navigate(`/start-role-user-account-activation/${token}`);
            } else {
              warningToast(
                'Token not present in response. Please check the email that was sent by the API.'
              );
            }
          } else {
            errorToast(response?.payload?.massage || 'Unable to generate token.');
          }
        })
        .catch(() => {
          errorToast('Something went wrong while requesting token.');
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    },
  });

  return (
    <Container className='py-5 d-flex justify-content-center align-items-center'>
      <Card className='p-4' style={{maxWidth: 480, width: '100%'}}>
        <h5 className='mb-3 text-center'>Start Role Account Activation Tester</h5>
        <p className='text-muted text-center'>
          Submit an email to trigger forgot-password and redirect to the account activation flow.
        </p>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className='mb-3' controlId='activationTestEmail'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='email'
              placeholder='Enter email'
              {...formik.getFieldProps('email')}
              isInvalid={formik.touched.email && !!formik.errors.email}
              disabled={isSubmitting}
            />
            {formik.touched.email && formik.errors.email && (
              <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
            )}
          </Form.Group>
          <Button type='submit' variant='primary' className='w-100' disabled={isSubmitting}>
            {isSubmitting ? 'Generating token...' : 'Generate Token & Redirect'}
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default StartRoleAccountActivationTest;
